import { Item } from "./Item"

export interface MilestonePlanningDTO {
  plannedItems: Item[]
  excludedItems: Item[]
  completedItems: Item[]
}

export interface MilestonePlanningUpdate {
  excluded: boolean
  itemIds: string[]
}

export interface MilestonePlanningMove {
  itemId: string
  previousItemId: string | null
  nextItemId: string | null
}

export class MilestonePlanning {
  plannedItems: Item[] = []
  excludedItems: Item[] = []
  completedItems: Item[] = []

  constructor(props?: Partial<MilestonePlanningDTO>) {
    if (!props) return
    this.plannedItems = props.plannedItems?.map(item => Item.create(item)) ?? []
    this.excludedItems = props.excludedItems?.map(item => Item.create(item)) ?? []
    this.completedItems = props.completedItems?.map(item => Item.create(item)) ?? []
  }
}
